import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { ReportService } from 'src/app/services/report.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-additional-info-report',
    templateUrl: './additional-info-report.component.html',
    styleUrls: ['./additional-info-report.component.scss']
})
export class AdditionalInfoReportComponent implements OnInit {
    additionalInfoReportForm: FormGroup
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;
    toMinDate: Date;
    toMaxDate: Date;
    constructor(private fb: FormBuilder, private reportService: ReportService) { }

    ngOnInit(): void {
        this.init()
    }
    init() {
        this.additionalInfoReportForm = this.fb.group({
            startDate: [null, Validators.required],
            endDate: [null, Validators.required],
            isCancellationDate: false
        });
    }
    Reset() {
        this.additionalInfoReportForm.reset()
    }

    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.additionalInfoReportForm.controls["startDate"].value;
        // this.toMaxDate = this.addMonths(this.toMinDate, 3);
    }
    generateExcel() {
        if (!this.additionalInfoReportForm.value.startDate && !this.additionalInfoReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date and To date should not be empty',
                position: 'center',

            })
        }
        else if (!this.additionalInfoReportForm.value.startDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date should not be empty',
                position: 'center',

            })
        }
        else if (!this.additionalInfoReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'End date should not be empty',
                position: 'center',

            })
        }
        else if (this.additionalInfoReportForm.value.startDate > this.additionalInfoReportForm.value.endDate) {
         if (this.additionalInfoReportForm.value.endDate) {

                Swal.fire({
                    icon: 'warning',
                    title: 'End Date should be greater than Start Date',
                    position: 'center',

                })
            }
        }
        else {
            let params:any={
                startDate:this.additionalInfoReportForm.value.startDate,
                endDate:this.additionalInfoReportForm.value.endDate,
                isCancellationDate:this.additionalInfoReportForm.value.isCancellationDate===true?false:true
            }
            this.reportService.getAdditionalInformationReport(params).subscribe( (data) =>{

                if (data) {
                    const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + data;
                    const downloadLink = document.createElement('a');
                    const fileName = 'AdditionalInformation.xls';
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                }

            });
        }




    }
}
